module.exports = __webpack_public_path__ + "img/monterey-top-angle.8b86da15.png";